<template>
    <div>
        <transition name="slide-right-panel">
            <div class="side-panel right-sidebar shw-rside" v-if="show">
                <div class="rpanel-title font-medium">
                    Emails <span @click="closeEmailThreadsPanel"><i
                        class="icon mdi mdi-close right-side-toggle"></i></span>
                </div>
                <div class="custom-scroll">
                    <div style="display: block; max-height: 90vh; overflow-y: scroll;">
                        <div v-for="thread in threads" :key="thread.id" class="mb-1">
                            <div class="mail-container p-3">
                                <h5 class="mb-0">
                                    {{thread.subject}}
                                </h5>
                                <div class="mail-content">
                                    <small class="text-muted">
                                        To: {{threadToField(thread)}}, From: {{threadFromField(thread)}}
                                    </small>
                                    <div class="flow-root"></div>
                                    <p style="min-height: 40px;">{{thread.preview}}
                                        <button @click.prevent="viewThread(thread.id)"
                                                class="btn btn-sm btn-outline-primary btn-rounded pull-right">View
                                        </button>
                                    </p>
                                </div>
                            </div>
                            <div class="flow-root"></div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {

        props: ["api", "show"],

        data () {
            return {
                threads: []
            };
        },

        mounted () {

            this.fetchThreads();

            let self = this;
            Bus.$on("email-updated", function () {
                self.fetchThreads();
            });

            Bus.$on("email-deleted", function () {
                self.fetchThreads();
            });

        },

        methods: {

            fetchThreads () {

                axios.get(this.api)
                .then(response => {
                    this.threads = response.data;
                });

            },

            threadToField (thread) {
                var email = "";

                if (!thread.last_email) {
                    return email;
                }

                if (thread.last_email.type === "sent") {
                    email = !_.isEmpty(thread.last_email.to_name) ? thread.last_email.to_name : thread.last_email.to;
                } else {
                    email = !_.isEmpty(thread.last_email.from_name) ? thread.last_email.from_name : thread.last_email.from;
                }

                return email;
            },

            threadFromField (thread) {
                var email = "";

                if (!thread.last_email) {
                    return email;
                }

                if (thread.last_email.type === "sent") {
                    email = !_.isEmpty(thread.last_email.from_name) ? thread.last_email.from_name : thread.last_email.from;
                } else {
                    email = !_.isEmpty(thread.last_email.to_name) ? thread.last_email.to_name : thread.last_email.to;
                }

                return email;
            },

            viewThread (threadId) {
                this.$emit("view-thread", threadId);
            },

            closeEmailThreadsPanel () {
                this.$emit("close-threads-panel");
            }

        }

    };
</script>

<style>

    .mail-container {
        border-bottom: 1px solid #f2f7f8;
    }

    .mail-content p {
        margin-bottom: 0;
    }

</style>
